import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RecommendationModel from 'tio-common/models/recommendation';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type SessionContextService from 'tio-employee/services/session-context';

export default class AuthenticatedRepaymentStrategyFinderDashboardQuestionnaireResultsRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;

  model({ recommendation_id }: { recommendation_id: string }) {
    return this.store.findRecord<RecommendationModel>('recommendation', recommendation_id);
  }
}
